import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ApiService } from 'app/shared/services/api.service';

@Component({
  selector: 'app-password-modal',
  template: `
    <h4 mat-dialog-title class="text-center">Enter Write Password</h4>
    <div mat-dialog-content>
    <mat-form-field appearance="fill">
      <mat-label>Enter Password</mat-label>
      <input matInput [(ngModel)]="password" type="password" placeholder="Enter your password" />
    </mat-form-field>

    </div>
    <div mat-dialog-actions align="end">
      <button mat-button class="btn btn-secondary mx-1" (click)="onCancel()">Cancel</button>
      <button mat-button class="btn btn-primary mx-1" (click)="onSubmit()">Submit</button>
    </div>
  `,
  styleUrls: ['./password-modal.component.scss']
})
export class PasswordModalComponent implements OnInit {

  password: string = '';
 

  constructor( @Inject(MAT_DIALOG_DATA) public data: { courseId: string },private dialogRef: MatDialogRef<PasswordModalComponent>,private apiService : ApiService,
    private router: Router) {

  }
  ngOnInit() {
  }
  

  onCancel(): void {
    this.dialogRef.close();
  }

  onSubmit() {
    this.apiService.checkCoursePassword(this.data.courseId,'',this.password).subscribe((res:any)=>{
      if (res.statusCode === 200 && res.data === true) {
        this.dialogRef.close('correct_password');
      }
      else alert('Incorrect Password');
    })
  }
}
